import React from "react";

type Props = {
  column: {
    filterValue: string | number;
    preFilteredRows: Array<any>;
    setFilter: (filter: string | undefined) => void;
  };
};

export default function DefaultColumnFilter({ column: { filterValue, preFilteredRows, setFilter } }: Props) {
  // const count = preFilteredRows.length;
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      // placeholder={`Search ${count} records...`}
    />
  );
}
